import { type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '../../utils/api';
import { useBffPatchMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { useBasket } from './useBasket';
import type { Basket, UpdateCartProductItem } from './model';

export const useUpdateProductItem = (): UseMutationResult<
    Basket,
    unknown,
    UpdateCartProductItem
> => {
    const { data } = useBasket();
    const queryClient = useQueryClient();

    return useBffPatchMutation<Basket, UpdateCartProductItem>(
        `/baskets/${data?.basketId}/product-item`,
        [],
        [],
        {
            basketCustomerId: data?.customerInfo?.customerId,
            onSuccess: async (basket): Promise<void> => {
                queryClient.setQueryData([BffQueryKey.BASKET], basket);

                await Promise.all([
                    queryClient.invalidateQueries([
                        QueryKey.APPLE_PAY_REQUEST,
                        JSON.stringify({
                            isFromPWA: 'true',
                            source: 'cart',
                        }),
                    ]),
                    queryClient.invalidateQueries([BffQueryKey.BASKET_AVAILABILITY], {
                        exact: false,
                    }),
                    queryClient.invalidateQueries([BffQueryKey.PAYMENT_METHODS, ''], {
                        exact: false,
                    }),
                ]);
            },
        },
    );
};
